import axios, { AxiosInstance } from "axios";
import { environment } from "../environment";

export class LocationServiceApi {
  axios: AxiosInstance;

  constructor() {
    this.axios = axios.create({
      baseURL: environment.locationApiUrl,
    });
  }
}
